import React, { useState } from "react";
// material
import {
  Card, Box, Typography,
  Modal,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  TextField,
} from '@mui/material';


import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';

import PropTypes from "prop-types";

import AlertDialog from '../../AlertDialog';
import { PushPaymentToDevice } from '../../../network/ProductionApp';
import { parseValidationErrorMessage } from "../../../utils/Utilities";
import { useAuth } from "../../customContextProviders/AuthContext";

// ----------------------------------------------------------------------


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 3,
  borderRadius: 1
};

const DeviceSchema = Yup.object().shape({
  amount: Yup.string()
    .required('Required'),

});



export default function TestSoundBoxPaymentModal({ opneAssignedModal, handleClose, _onAction, selectedMerchant }) {

  const {sessionUserData} = useAuth()
  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });

  const addDeviceFormik = useFormik({
    initialValues: {
      amount: '',
      organization_identifier: ''
    },
    validationSchema: DeviceSchema,
    onSubmit: () => {
      sendDummyPayment()

    }
  });


  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = addDeviceFormik;




  function sendDummyPayment() {
    PushPaymentToDevice(
      selectedMerchant?.device_id,
      "DEVICE_SPEAK_TXN",
      `${addDeviceFormik?.values?.amount}`,
      selectedMerchant?.id,
      sessionUserData?.user?.organization?.id
    )
      .then((_res) => {
        setAlertDialogMetas({ ...alertDialogMetas, message: "Payment sent successfully!", title: ''});
        setOpenAlertDialog(true)
      })
      .catch((err) => {
        setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(err), title: 'Test Payment Failed !'});
        setOpenAlertDialog(true)
      });
  }




  return (
    <Box data-testid='dummy-payment-modal'>
      <Modal
        open={opneAssignedModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >

        <FormikProvider value={addDeviceFormik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Box sx={style}>
              <Typography sx={{ fontSize: 18, fontWeight: 900 }}>
                Send dummy payment on <br /> {selectedMerchant?.name}'s AudioCube
              </Typography>
              {/* <FormControl fullWidth sx={{ mt: 5 }}>
                <InputLabel id="organization-label">Organization</InputLabel>
                <Select
                  labelId="organization-label"
                  id="organization-select"
                  label="Organization"
                  disabled
                  {...getFieldProps('organization_identifier')}
                  error={Boolean(touched.organization_identifier && errors.organization_identifier)}
                  helperText={touched.organization_identifier && errors.organization_identifier}
                >
                  <MenuItem value={APP_CONSTANTS.BOB_ORGANIZATION_IDENTIFIER}>BOB</MenuItem>
                  <MenuItem value={APP_CONSTANTS.BOI_ORGANIZATION_IDENTIFIER}>BOI</MenuItem>
                  <MenuItem value={APP_CONSTANTS.SWINKPAY_ORGANIZATION_IDENTIFIER}>SwinkPay</MenuItem>
                  <MenuItem value={APP_CONSTANTS.AIRTEL_ORGANIZATION_IDENTIFIER}>Airtel</MenuItem>
                  <MenuItem value={APP_CONSTANTS.MAXIMUS_ORGANIZATION_IDENTIFIER}>Maximus</MenuItem>
                  <MenuItem value="NA">NA</MenuItem>
                </Select>
              </FormControl> */}

                <FormControl fullWidth sx={{ mb: 3, mt: 2}}>
                  <TextField
                    id="amount"
                    name="amount"
                    label="Enter Amount "
                    type="number"
                    {...getFieldProps('amount')}
                    error={Boolean(touched.amount && errors.amount)}
                    helperText={touched.amount && errors.amount}
                  />
                </FormControl>
              <Box display="flex" justifyContent="flex-end" alignItems="center">

              <Button data-testId='send-button' variant="contained" type='submit' size="medium" >Send</Button>
              </Box>
            </Box>
          </Form>
        </FormikProvider>

      </Modal>


      <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title}
        btnLabel={alertDialogMetas?.btnLabel} handleClose={() => setOpenAlertDialog(false)} />
    </Box>
  );
}


TestSoundBoxPaymentModal.propTypes = {
  opneAssignedModal: PropTypes.bool,
  handleClose: PropTypes.func,
  _onAction: PropTypes.func,
  selectedMerchant: PropTypes.object
}
